import React from 'react'
import './Hero.css'
import { Link } from 'react-router-dom'

const Hero = () => {
  return (
    <div className='hero'>
      <div className='hero-over'>
            <div className='hero-title'>
              <h3>Hello, I'm Antuan</h3>
              <h1>Web <span id='developer'>Developer</span></h1>
            </div>
            <div className='hero-btn'>
              <Link to="/contact">Let’s Work Together</Link>
            </div>
        </div>
    </div>
  )
}

export default Hero